module.exports = __webpack_public_path__ + "static/media/bug.a7a0b097.jpg";